import { render } from "./GrupoView.vue?vue&type=template&id=100b8500"
import script from "./GrupoView.vue?vue&type=script&lang=js"
export * from "./GrupoView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__